import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const opportunities = [
  {
    path: '/vector/opportunities',
    name: 'vector-opportunities-home',
    component: () => import('@/pages/vector/opportunities/OpportunitiesListPage.vue'),
    meta: {
      title: 'Opportunities',
      resource: 'Vector',
      action: 'read',
      subject: 'Opportunity',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/opportunities/:opportunity_uuid',
    name: 'vector-opportunities-opportunity-details',
    component: () => import('@/pages/vector/opportunities/OpportunityDetailPage.vue'),
    meta: {
      title: 'Opportunity Details',
      resource: 'Vector',
      action: 'read',
      subject: 'Opportunity',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default opportunities
